import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=44f1fbe4"
var script = {}
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=44f1fbe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports